import { Link, useLocation } from "react-router-dom";
import useMeta from "@/hooks/useMeta";

export default function NotFound() {
  const location = useLocation();

  useMeta({
    title: "页面不存在 - 大象传媒",
    description: "您访问的页面不存在或已被移除，请返回大象传媒首页浏览更多影视作品与资讯。",
    keywords: "大象传媒,页面不存在",
  });

  return (
    <div className="mx-auto flex min-h-[70vh] w-full flex-col items-center justify-center px-4 py-16 text-center md:px-6">
      <span className="font-heading text-7xl font-black text-primary-200 md:text-9xl">
        404
      </span>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
        页面不存在
      </h1>
      <p className="mt-2 text-sm text-foreground-600">
        您访问的地址 <span className="text-foreground-800">{location.pathname}</span> 暂时无法找到
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
        >
          返回首页
        </Link>
        <Link
          to="/news"
          className="rounded-md border border-primary-300 bg-primary-50 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-100"
        >
          浏览资讯
        </Link>
      </div>
    </div>
  );
}